import {
  useAsync
} from "./chunk-FVZAR5OH.mjs";

// src/useDistributorsData.ts
var createUseDistributorsData = (httpClient) => () => {
  return useAsync(
    async () => {
      const response = await httpClient.get("/distributors");
      return response.data;
    },
    { deps: [] }
  );
};
export {
  createUseDistributorsData
};
